/* eslint-disable no-restricted-globals */
import http from '../../../Utils/http';
import { toast } from 'react-toastify';
const InviteToDisplays = {
  name: 'inviteToDisplays',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
    status: null,
  },
  reducers: {
    getReceived(state, payload) {
      return {
        ...state,
        data: payload.data,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },
    addData(state, payload) {
      return {
        ...state,
        data: payload,
      };
    },
    // Standard request lifecycle reducers used by effects
    inviteToDisplaysRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        status: null,
      };
    },
    inviteToDisplaysSucceeded(state, payload) {
      return {
        ...state,
        loading: false,
        data: payload || state.data,
        error: '',
        status: 'pending',
      };
    },
    inviteToDisplaysRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload || 'Request failed',
      };
    },
    clearInviteDisplayState(state) {
      return {
        ...state,
        data: [],
        loading: false,
        error: '',
        status: null,
      };
    }
  },
  effects: (dispatch) => ({
    async sendData(data) {
      dispatch.inviteToDisplays.addData(data);
    },
    async emptyData(data) {
      dispatch.inviteToDisplays.addData('');
    },

    async postData(data, state) {
      const { list, message } = data
      const extractDetails = (message) => {
        const nameMatch = message.match(/Hello\s*<strong>(.*?)<\/strong>/i);
        const name = nameMatch ? nameMatch[1] : null;
        const hrefMatch = message.match(/<a\s+href=["'](.*?)["']/i);
        const href = hrefMatch ? hrefMatch[1] : null;
        const invitedByMatch = message.match(
          /invited[\s\S]*?by\s*<strong>\s*([^<]*?)\s*<\/strong>/i
        );
        const sender = invitedByMatch ? invitedByMatch[1].trim() : null;

        return { name, href, sender };
      };
      const details = extractDetails(message || '');
      const userName = JSON.parse(localStorage.getItem('userInfo')).name;
      const senderDisplay = details?.sender || userName;
      const emailMessage = `<html>
       <head>
         <link rel="preconnect" href="https://fonts.googleapis.com">
         <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
         <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
         <style>
           body {
             font-family: "Montserrat", sans-serif;
             font-optical-sizing: auto;
             font-weight: 400;
             font-style: normal;
           }
           img {
             width: 30%;
             height: auto;
             display: block;
             margin-left: auto;
             margin-right: auto;
             justify-content: center;
             align-items: center;
           }
         </style>
       </head>
       <body>
         <img src="https://app.savvydisplays.com//static/media/SavvyDisplaysLogo.8278eb24aba7be546995.png" alt="Savvy Displays Logo">
         
         <div style="margin: 0 20px; text-align: center;">
           <h2 style="margin: 0 20px;">You have been invited to SavvyDisplays</h2>
           <br/>
           
          <p style="text-align: left; margin: 0 30px;">
            Hello <strong>${details?.name || ''}</strong>,
          </p>

          <p style="text-align: left; margin: 10px 30px;">
            You have been invited by <strong>${senderDisplay}</strong> to access their digital signage displays on <strong>SavvyDisplays</strong>.
          </p>

          <p style="text-align: left; margin: 10px 30px;">
            Through this invitation, you will be able to browse available digital signage displays, purchase ad placements, create and manage advertising campaigns, and track performance with detailed reporting.
          </p>

          <p style="text-align: left; margin: 10px 30px;">
            <strong>If you are already on SavvyDisplays:</strong><br/>
            Log in with your existing account to view and access the shared displays.
          </p>

          <p style="text-align: left; margin: 10px 30px;">
            <strong>If you are new to SavvyDisplays:</strong><br/>
            Click the link below to create your account using this email address and get started.
          </p>

          <p style="text-align: center; margin: 20px 30px;">
            <a
              href="${details?.href || ''}"
              style="display:inline-block; padding: 10px 18px; background: rgb(90, 59, 140); color:#fff; text-decoration:none; border-radius:4px; font-weight:600;"
            >
              Accept Invitation
            </a>
          </p>

          <p style="text-align: left; margin: 10px 30px;">
            If you have any questions, please contact the sender or our support team.
          </p>

          <p style="text-align: left; margin: 10px 30px;">
            We look forward to helping you launch and manage your campaigns.
          </p>

          <p style="text-align: left; margin: 10px 30px;">
            <strong>Best regards,</strong><br/>
            The SavvyDisplays Team
          </p>
       
           <p style="margin: 20px 30px; color:rgb(63, 63, 63);">
             If you are having trouble signing in, please email us at 
             <a href="mailto:support@savvydisplays.com">support@savvydisplays.com</a>, or call 
             <a href="tel:+18553815563">+1-855-381-5563 ext. 104</a>.
           </p>
           <br/>
           <span style="color:black;">
             POWERFUL <span style="font-weight: bolder; color: rgb(90, 59, 140);">DIGITAL MARKETING</span> FOR 
             <span style="font-weight: bolder; color:rgb(90, 59, 140);">SALES ACCELERATION</span>
           </span>
           <br/><br/>
           www.triggerpointmedia.com
           <br/><br/>
         </div>
       </body>
       </html>
       `

      // [{display_id: 4, zonesIdsList: [10], adv_id: 399}]
      // await zones?.forEach((item) => {
      //   if (obj[item?.displayId]) {
      //     obj[item?.displayId]?.zonesIdsList.push(item?.id);
      //   } else {
      //     obj[item?.displayId] = {
      //       display_id: item?.displayId,
      //       zonesIdsList: [item?.id],
      //       adv_id: advId,
      //     };
      //   }
      // });

      const id = JSON.parse(localStorage.getItem('userInfo')).org_id;
      const response = await http.post(
        `savvy/organization/invite-to-display/${id}`,
        { list: list, message: emailMessage, origin: location.origin }
      );

      const skippedHiddenDisplayIds = response?.data?.skipped_hidden_display_ids;
      if (Array.isArray(skippedHiddenDisplayIds) && skippedHiddenDisplayIds.length > 0) {
        try {
          toast.warning(
            response?.data?.warning ||
              'Hidden displays cannot be invited to and were skipped.'
          );
        } catch (e) {}
      }

      return response?.data;
    },
    // async getDsoDisplaysWithZones({ page, size, org_id }) {
    //   const id = JSON.parse(localStorage.getItem('userInfo')).org_id;

    //   let url = `savvy/displays/${id}?page=${page}&size=${size}`;
    //   const response = await http.get(`${url}`);

    // },

    async request_invite_to_display({ displayId }) {
      try {
        this.inviteToDisplaysRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const user_id = userInfo.id;
        const org_id = userInfo.org_id;
        const id = displayId;
        const origin = window.location.origin;
        const onBehalfOf = JSON.parse(localStorage.getItem('onBehalfName'));
        const url = `savvy/displays/req_for_display_invite/${id}?user_id=${user_id}&org_id=${org_id}&on_behalf_of=${onBehalfOf}&origin=${origin}`;
        const response = await http.post(url);

        if (response && response?.data?.message === "request_created") {
          this.inviteToDisplaysSucceeded(response.data.data);
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: 'Request sent successfully!',
              show: true,
            },
          });
        }
      } catch (err) {
        console.log('err', err);
        this.inviteToDisplaysRequestFailed(err?.response?.data?.message || err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: err?.response?.data?.message || err.message,
            show: true,
          },
        });
      }
    },
    async clearDisplayInviteState() {
      try {
        this.clearInviteDisplayState();
      } catch (err) {
        console.error(err);
      }
    },
  }),
};

export default InviteToDisplays;